import { render, staticRenderFns } from "./sjAreaUser.vue?vue&type=template&id=51338b04&scoped=true&"
import script from "./sjAreaUser.vue?vue&type=script&lang=js&"
export * from "./sjAreaUser.vue?vue&type=script&lang=js&"
import style0 from "./sjAreaUser.vue?vue&type=style&index=0&id=51338b04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51338b04",
  null
  
)

export default component.exports